import { apiClient } from '../client';

interface AreaRequestResponse {
  success: boolean;
  message: string;
  isNew: boolean;
}

export const areaRequestsApi = {
  submit: async (data: { latitude: number; longitude: number }): Promise<AreaRequestResponse> => {
    const response = await apiClient.post<AreaRequestResponse>('/v1/area-requests', data);
    return response.data;
  },
};
